export enum AccessMode {
  FULL = 'full',
  DOMAIN = 'domain',
  LIMITED= 'limited',
}